import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  MdLockClock,
  MdNotifications,
  MdOutlineLockClock,
  MdTimer,
} from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoint } from "../../utils/endpoints";
import { isInvalidTokenMessage, notifyInvalidToken } from "../../utils/invalidSession";
import { toast } from "react-toastify";
import Notification from "../../assets/image/Notification.svg";

import { useDataContext } from "../DataContext";
import { clearBookingMgmtSessionUi } from "../../Pages/BookingManagement/bookingListSessionUi";

const Header = () => {
  const { modules, updateModules, setRole, setVendorProfile, setProfileUnderReview } = useDataContext();
  const navigate = useNavigate();
  const headerTitle = useLocation();
  const { pathname } = headerTitle;

  let title = pathname.split("/")[1]?.replace(/-/g, " ") || "";
  if (pathname.startsWith("/inventory")) {
    title = "Inventory";
  } else if (pathname.startsWith("/product-management/offers")) {
    title = "Product Management — Offers";
  } else if (pathname.startsWith("/product-management/rent")) {
    title = "Product Management — Rent";
  } else if (pathname.startsWith("/product-management/shop")) {
    title = "Product Management — Shop";
  } else if (pathname.startsWith("/product-management")) {
    title = "Product Management";
  } else if (pathname.startsWith("/merchant-management/rent")) {
    title = "Merchant Management — Rent";
  } else if (pathname.startsWith("/merchant-management/shop")) {
    title = "Merchant Management — Shop";
  } else if (pathname.startsWith("/merchant-management")) {
    title = "Merchant Management";
  } else if (pathname.startsWith("/service-management/rejected-services")) {
    title = "Service Management — Rejected Services";
  } else if (pathname.startsWith("/service-management")) {
    title = "Service Management";
  } else if (pathname.startsWith("/support-and-help/ticket/")) {
    title = "Support & help — Ticket details";
  } else if (pathname.startsWith("/support-and-help")) {
    title = "Support & help";
  } else if (
    pathname === "/Terms-&-Condition" ||
    pathname.endsWith("/Terms-&-Condition")
  ) {
    title = "Terms & Conditions";
  }

  useEffect(() => {
    if (
      pathname !== "/Terms-&-Condition" &&
      !pathname.endsWith("/Terms-&-Condition")
    ) {
      return undefined;
    }
    const prev = document.title;
    document.title = "Terms & Conditions | Event-Vendor panel";
    return () => {
      document.title = prev;
    };
  }, [pathname]);

  const [show, setShow] = useState(false);
  const [profile, setProfile] = useState();
  const handleClose = () => {
    setShow(false);
    setBox(false);
  };
  const handleShow = () => setShow(true);

  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);
  const [box, setBox] = useState(false);
  const getAminProfile = async () => {
    // Invalid session uses notifyInvalidToken (popup), not PopUp directly.
    const response = await handleApiCall(
      "get",
      `${endpoint.getAdminProfile}`,
      {}
    );
    try {
      // Handle success response (HTTP 200 with code 200)
      if (response?.data?.code === 200) {
        const data = response?.data?.data;
        const vendor = data?.vendor; // { name, email, profile_pic }
        setProfile(vendor);
        if (vendor) setVendorProfile(vendor);
        if (data?.role) setRole(data.role);
        setProfileUnderReview(false);
        return;
      }

      // Response body (success or error from axios)
      const resData = response?.response?.data ?? response?.data;
      const code = resData?.code;
      const errorMessage = resData?.errorMessage || resData?.message || "Something went wrong";

      if (code === 400 && (errorMessage === "Profile under review" || resData?.errorMessage === "Profile under review")) {
        setProfileUnderReview(true);
        navigate("/profile-under-review", { replace: true });
        return;
      }
      if (isInvalidTokenMessage(errorMessage) || code === 404) {
        notifyInvalidToken(errorMessage || "Your token is invalid!");
        return;
      }
      if (code === 401) {
        toast.error(errorMessage || "Unauthorized");
        clearBookingMgmtSessionUi();
        localStorage.clear();
        navigate("/", { replace: true });
        return;
      }
      console.log(errorMessage, "Error Msg Header");
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getAminProfile();
  }, [pathname]);
  return (
    <>
      <div className="main-content-header sticky-top">
        <div className="mch-heading-wrapper mb-0">
          <h2 className="mch-heading mb-0 capitalize font-BonaNovabold font-normal text-[19px] leading-[23px] text-[#2B2B2B]">
            {title}
          </h2>
        </div>

        <div className="mch-right-items items-center flex">
          {/* Notification Button */}
          <button
            className="bg-transparent border-0 p-2 text-2xl cursor-pointer mr-3 relative"
            onClick={() => navigate("/notifications")}
          >
            <img src={Notification} alt="Notification" className="w-5 h-5" />
          </button>
        </div>
      </div>

      <Modal
        dialogClassName="modal-custom-sm"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Body className="p-0">
          <div className="card logout-card common_box">
            <div className="card-body common_box_body py-4 px-3">
              <p className="modalTitle text-center mb-2 fw-bold">
                Are you sure you want to
                <br />
                Logout
              </p>
              <form className="custom_form">
                <div className="btn-wrapper text-center">
                  <Link
                    className="btn btn-form btn-cancel"
                    onClick={handleClose}
                  >
                    No
                  </Link>
                  <button
                    className="btn btn-form btn-add"
                    onClick={() => {
                      clearBookingMgmtSessionUi();
                      localStorage.clear();
                      navigate("/");
                    }}
                  >
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
